import React from 'react';

import { useSwitch } from '../../../../hooks/useSwitch';
import { Guid } from '../../../../store/model/guid';
import { FlipCard as FlipCardModel, FlipCardFace as FlipCardFaceModel, FlipCardType } from '@ael/core-api';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import './FlipCard.scss';

type FlipCardProps = {
  widgetId: Guid;
  model: FlipCardModel;
  getAssetUrl: (assetId: Guid) => string | null;
  onFlipped: () => void;
};

export const FlipCard = (props: FlipCardProps) => {
  const frontSwitch = useSwitch(true);

  return (
    <>
      <div
        // flicard
        className={classNames('uno-w-65 uno-h-80  uno-perspective-1000 uno-overflow-visible uno-rounded-lg')}
      >
        <div
          // flipcard-inner
          className={classNames(
            'uno-relative uno-w-full uno-h-full uno-transition-650 uno-preserve-3d',
            'uno-rounded-lg uno-border uno-border-stroke uno-border-solid',
            {
              'uno-transform-rotate-y-180': !frontSwitch.isOn,
            }
          )}
        >
          <FlipCardFace
            widgetId={props.widgetId}
            flipCardFace={props.model.front}
            getAssetUrl={props.getAssetUrl}
            flipSide={() => {
              frontSwitch.toggle();
              props.onFlipped?.();
            }}
          />
          <FlipCardFace
            widgetId={props.widgetId}
            flipCardFace={props.model.back}
            getAssetUrl={props.getAssetUrl}
            flipSide={frontSwitch.toggle}
            isBack
          />
        </div>
      </div>
    </>
  );
};

type FlipCardFaceProps = {
  widgetId: Guid;
  flipCardFace: FlipCardFaceModel;
  getAssetUrl: (assetId: Guid) => string | null;
  flipSide: () => void;
  isBack?: true;
};
const FlipCardFace = (props: FlipCardFaceProps) => {
  return (
    <>
      <div
        className={classNames(
          'uno-absolute uno-w-full uno-h-full uno-backface-hidden uno-bg-surface uno-overflow-hidden uno-rounded-lg uno-cursor-pointer uno-text-center',
          {
            'uno-p-4 uno-pt-6 uno-flex uno-justify-center uno-items-center':
              props.flipCardFace.type === FlipCardType.text,
            'uno-transform-rotate-y-180': props.isBack,
          }
        )}
        onClick={props.flipSide}
      >
        {props.flipCardFace.type === FlipCardType.imageFull && (
          <div className="uno-h-full uno-w-full">
            <img
              className="uno-w-full uno-h-full uno-object-cover"
              src={props.getAssetUrl(props.flipCardFace.assetId) ?? undefined}
              alt="your card"
            />
          </div>
        )}
        <div className="uno-absolute uno-left-0 uno-bottom-0 uno-top-0 uno-right-0 hover:uno-text-text-hover uno-text-text-muted">
          <div
            className={classNames(
              'uno-absolute uno-flex uno-flex-row uno-flex-justify-end uno-gap-2',
              'uno-bottom-5 uno-right-5'
            )}
          >
            <FontAwesomeIcon icon={regular('repeat')} />
          </div>
        </div>
        {props.flipCardFace.type === FlipCardType.text && (
          <div className="flip-card__text" dangerouslySetInnerHTML={{ __html: props.flipCardFace.text }} />
        )}
      </div>
    </>
  );
};
